/* eslint-disable no-unused-vars */
import axios from "axios"

export const fetchLoadHistory = async ({ file, weekId }) => {
  const formData = new FormData()
  formData.append("id", weekId)
  formData.append("file", file)
  const result = await axios.post("/api/Accounting", formData)
  return result.data
}

export const saveImportedLoads = async data => {
  const result = await axios.post(`/api/Accounting/SaveImportedLoads`, data)
  return result.data
}
